import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ContentWrapper,
  Container,
  SuccesPage,
  SuccessImg,
  GoBackButton,
  Title,
  Description,
} from './Success.styled';
import SuccessIco from '../../assets/images/success.webp';

export const Success = ({closeSuccess}:any) => {
  const [flag, setFlag] = useState(false);
  const { t } = useTranslation();
  const hover = () => setFlag(true);
  const unHover = () => setFlag(false);
  return (
    <SuccesPage>  
      <Container>
        <ContentWrapper>
          <SuccessImg src={SuccessIco} alt='access' />
          <Title>{t('tnx')}</Title>
          <Description>{t('connect')}</Description>
          <GoBackButton
            type='button'
            onClick={() => closeSuccess()}
            onMouseEnter={hover}
            onMouseLeave={unHover}
            hovered={flag}>
            {t('goback')}
          </GoBackButton>
        </ContentWrapper>
      </Container>
    </SuccesPage>
  );
};
